import apiRequest from "../../utils/apiRequest";

const createTeamMemberApi = async (teamMemberData) => {
    return await apiRequest("member", "post", teamMemberData);
};

export default createTeamMemberApi;
